module.exports = __webpack_public_path__ + "static/media/building-profile.d948ab4e.svg";